(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-header"] && !Shopify.designMode) return;
  try {
    
  class CollectionHeaderRail {
    constructor(section) {
      this.section = section;
      this.scroller = section.querySelector('[data-collection-header-scroller]');
      this.nav = section.querySelector('[data-collection-header-nav]');
      this.prevButton = this.nav?.querySelector('[data-direction="prev"]');
      this.nextButton = this.nav?.querySelector('[data-direction="next"]');
      this.content = section.querySelector('[data-collection-header-content]');
      this.readMoreLink = section.querySelector('[data-collection-header-read-more]');

      if (this.readMoreLink && this.content) {
        this.handleResize = () => {
          this.updateButtons();
          this.updateReadMore();
        };
      }

      if (!this.scroller || !this.prevButton || !this.nextButton) {
        this.updateReadMore();
        return;
      }

      this.handleScroll = this.updateButtons.bind(this);
      this.handlePrevClick = () => this.scrollByCard(-1);
      this.handleNextClick = () => this.scrollByCard(1);
      this.handleResize = () => {
        this.updateButtons();
        this.updateReadMore();
      };
      //this.handlePointerDown = this.onPointerDown.bind(this);
      //this.handlePointerMove = this.onPointerMove.bind(this);
      //this.handlePointerUp = this.onPointerUp.bind(this);
      this.handleClickCapture = this.onClickCapture.bind(this);

      this.isPointerDown = false;
      this.isDragging = false;
      this.pointerId = null;
      this.startX = 0;
      this.startScrollLeft = 0;

      this.prevButton.addEventListener('click', this.handlePrevClick);
      this.nextButton.addEventListener('click', this.handleNextClick);
      this.scroller.addEventListener('scroll', this.handleScroll, { passive: true });
      //this.scroller.addEventListener('pointerdown', this.handlePointerDown);
      //this.scroller.addEventListener('pointermove', this.handlePointerMove);
      //this.scroller.addEventListener('pointerup', this.handlePointerUp);
      //this.scroller.addEventListener('pointercancel', this.handlePointerUp);
      //this.scroller.addEventListener('click', this.handleClickCapture, true);
      window.addEventListener('resize', this.handleResize);

      this.updateButtons();
      this.updateReadMore();
    }

    scrollByCard(direction) {
      const card = this.scroller.querySelector('.collection-header__related-card');
      const cardWidth = card ? card.getBoundingClientRect().width : this.scroller.clientWidth;
      const styles = window.getComputedStyle(this.scroller);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const amount = (cardWidth + gap) * direction;

      this.scroller.scrollBy({ left: amount, behavior: 'smooth' });
    }

    updateButtons() {
      const maxScrollLeft = this.scroller.scrollWidth - this.scroller.clientWidth;
      const scrollLeft = this.scroller.scrollLeft;
      const atStart = scrollLeft <= 4;
      const atEnd = scrollLeft >= maxScrollLeft - 4 || maxScrollLeft <= 0;

      this.prevButton.disabled = atStart;
      this.nextButton.disabled = atEnd;
      this.prevButton.classList.toggle('swiper-button-disabled', atStart);
      this.nextButton.classList.toggle('swiper-button-disabled', atEnd);
      this.nav.hidden = window.innerWidth < 990 || maxScrollLeft <= 0;
    }

    updateReadMore() {
      if (!this.readMoreLink || !this.content) return;

      if (!this.content.classList.contains('truncate-text')) {
        this.readMoreLink.hidden = true;
        return;
      }

      window.requestAnimationFrame(() => {
        const hasOverflow = this.content.scrollHeight > this.content.clientHeight + 1;
        this.readMoreLink.hidden = !hasOverflow;
      });
    }

    onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      this.isPointerDown = true;
      this.isDragging = false;
      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScrollLeft = this.scroller.scrollLeft;

      this.scroller.setPointerCapture(event.pointerId);
    }

    onPointerMove(event) {
      if (!this.isPointerDown || this.pointerId !== event.pointerId) return;

      const deltaX = event.clientX - this.startX;

      if (!this.isDragging && Math.abs(deltaX) > 6) {
        this.isDragging = true;
        this.scroller.classList.add('is-dragging');
      }

      if (!this.isDragging) return;

      this.scroller.scrollLeft = this.startScrollLeft - deltaX;
    }

    onPointerUp(event) {
      if (this.pointerId !== event.pointerId) return;

      this.isPointerDown = false;
      this.pointerId = null;
      this.scroller.classList.remove('is-dragging');

      window.setTimeout(() => {
        this.isDragging = false;
      }, 0);
    }

    onClickCapture(event) {
      //if (!this.isDragging) return;

      //console.log('click captured', event);

      //location.href = event.target.closest('.collection-header__related-card')?.href;

      //event.preventDefault();
      //event.stopPropagation();
    }
  }

  document.querySelectorAll('.collection-header').forEach((section) => {
    if (section.dataset.collectionHeaderReady === 'true') return;
    section.dataset.collectionHeaderReady = 'true';
    new CollectionHeaderRail(section);
  });

  } catch(e) { console.error(e); }
})();
})();
